module.exports = __webpack_public_path__ + "static/img/hzsl.ec43eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzsl.png
// module id = tPuo
// module chunks = 0